export enum CardSize {
  Large = 'lg',
  Medium = 'md',
  Small = 'sm',
}
